const getNestedValue: any = (path: Array<string | number>, object: object) =>
  path.reduce((xs: any, x: any) => (xs && xs[x] ? xs[x] : null), object);

export { getNestedValue };
